import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { FundCustomQuestionAnswerListForDisplay } from '@Types';

export const useGetProjectAdditionalQuestionAnswers = () => {
  const [fetch, response] = useRequest<FundCustomQuestionAnswerListForDisplay>();

  const getProjectAdditionalQuestionAnswers = useCallback(
    (projectId: number) => fetch(API.paths.project_additional_question_answers(projectId), 'get'),
    [fetch],
  );

  return [getProjectAdditionalQuestionAnswers, response] as const;
};
